import React from 'react';
import { useLanguage } from '../../hooks/useLanguage';

interface BlueprintProps {
    load: number; // Nombre de fenêtres ouvertes
}

export const SystemBlueprint: React.FC<BlueprintProps> = ({ load }) => {
    const { t } = useLanguage();
    
    return (
        <div className="absolute inset-0 w-full h-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
            {/* Grille hexagonale high-tech */}
            <div className="absolute inset-0 opacity-15">
                <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <pattern id="hexGrid" x="0" y="0" width="60" height="52" patternUnits="userSpaceOnUse">
                            <path d="M30 2 L45 12 L45 32 L30 42 L15 32 L15 12 Z" 
                                  fill="none" 
                                  stroke="rgba(59, 130, 246, 0.3)" 
                                  strokeWidth="1"/>
                        </pattern>
                    </defs>
                    <rect width="100%" height="100%" fill="url(#hexGrid)" />
                </svg>
            </div>

            {/* Lignes de données qui traversent l'écran */}
            <div className="absolute inset-0">
                {[...Array(6)].map((_, i) => (
                    <div
                        key={i}
                        className="absolute h-px bg-gradient-to-r from-transparent via-cyan-400/20 to-transparent opacity-30"
                        style={{
                            top: `${15 + i * 15}%`,
                            width: '100%',
                            animation: `dataFlow ${3 + i * 0.5}s ease-in-out infinite`,
                            animationDelay: `${i * 0.8}s`
                        }}
                    />
                ))}
            </div>

            {/* Texte de statut système discret */}
            <div className="absolute bottom-8 left-8 text-xs text-cyan-400/60 font-mono space-y-1">
                <div>{t('systemBlueprint.version')}</div>
                <div>{t('systemBlueprint.secureKernel')}</div>
                <div>{t('systemBlueprint.encryption')}</div>
            </div>

            {/* Effet de scan subtil */}
            <div 
                className="absolute inset-0 bg-gradient-to-b from-transparent via-cyan-400/5 to-transparent h-8 opacity-40"
                style={{
                    animation: 'scanLine 4s ease-in-out infinite'
                }}
            />

            {/* Vignette */}
            <div className="absolute inset-0 bg-gradient-radial from-transparent via-transparent to-black/30" />
        </div>
    );
};
